import React from 'react';

import classes from './AddonsHeader.scss';

const addonsHeader = (props) => {
    return (
        <header className={classes.Header}>
            {props.children}
        </header>
    );
}

export default addonsHeader;


// WEBPACK FOOTER //
// ./src/components/UI/Headers/AddonsHeader/AddonsHeader.js